import { render, staticRenderFns } from "./ReportRegistry.vue?vue&type=template&id=26d7c11d&scoped=true&"
import script from "./ReportRegistry.vue?vue&type=script&lang=ts&"
export * from "./ReportRegistry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d7c11d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d7c11d')) {
      api.createRecord('26d7c11d', component.options)
    } else {
      api.reload('26d7c11d', component.options)
    }
    module.hot.accept("./ReportRegistry.vue?vue&type=template&id=26d7c11d&scoped=true&", function () {
      api.rerender('26d7c11d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/management/views/ReportRegistry.vue"
export default component.exports